import { useState } from 'react'
import { Tooltip } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { useParams } from 'react-router-dom'

import Link from '~/core/Link'
import Box from '~/core/Box'
import getColor from '~/lib/getColor'

import ContactFictivModal from './ContactFictivModal'
import styles from './styles.css'

const DOWNLOAD_DFM_REPORT = 'download-dfm-report'
const PLACEMENT = 'im-dfm-modal-headerd'

type DownloadDfmIconPropsType = {
    totalImDfmFeedbacks: number
    orderId?: string
}

const DownloadDfmIcon = (props: DownloadDfmIconPropsType) => {
    const { totalImDfmFeedbacks, orderId } = props

    const { qmrId } = useParams<{ qmrId: string }>()

    const [modalVisible, setModalVisible] = useState<boolean>(false)

    const showFictivAlertModal = totalImDfmFeedbacks >= 50

    const onClickDownloadIcon = () => {
        setModalVisible(true)
    }

    return (
        <Box
            data-test-target="download-im-dfm-modal"
            padding={orderId ? '2px 60px 0 0' : '6px 8px 0 0'}
        >
            <Link
                name="download-icon"
                placement={PLACEMENT}
                target="_blank"
                rel="noopener noreferrer"
                onClick={showFictivAlertModal ? onClickDownloadIcon : undefined}
                href={
                    !showFictivAlertModal
                        ? `/${DOWNLOAD_DFM_REPORT}/${qmrId}/customer`
                        : null
                }
            >
                <Tooltip placement="top" title="Download report as PDF">
                    <DownloadOutlined
                        className={styles.downloadIcon}
                        style={{
                            fontSize: '18px',
                            color: getColor('blackAlpha45'),
                        }}
                    />
                </Tooltip>
            </Link>
            {modalVisible && (
                <ContactFictivModal onClose={() => setModalVisible(false)} />
            )}
        </Box>
    )
}

export default DownloadDfmIcon
